export const IDENTITY_SDK_RESET_COOKIE = "identitySdkResetRequired";
export const GTM_ID = "GTM-NR75XMD";
export const AUTH_LAST_ACTION = {
  SIGNIN_EMAIL: 7,
  SIGNIN_SOCIAL: 6,
  SIGNUP_EMAIL: 2,
  SIGNUP_SOCIAL: 1,
  LINK_ACCOUNTS: 3
};
